export const evaluationMethods = {
    methods: {
        getEvaluationScore(data) {
            if (data.answers.length === 3) {
                let evaluationSubscale = {
                    communicationPoints: 0,
                    communicationPercentage: 0,
                    relationshipPoints: 0,
                    relationshipPercentage: 0,
                    planningPoints: 0,
                    planningPercentage: 0,
                    resultsPoints: 0,
                    resultsPercentage: 0,
                    resiliencePoints: 0,
                    resiliencePercentage: 0,
                    supportingPoints: 0,
                    supportingPercentage: 0,
                    progressionPoints: 0,
                    progressionPercentage: 0,
                }

                for (let a = 0; a < data.answers.length; a++) {
                    //elke set antwoorden van elke evaluator
                    for (let c = 0; c < data.answers[a].categories.length; c++) {
                        switch (data.answers[a].categories[c].category) {
                            case "communication":
                                for (let q = 0; q < data.answers[a].categories[c].questions.length; q++) {
                                    evaluationSubscale.communicationPoints = (evaluationSubscale.communicationPoints + data.answers[a].categories[c].questions[q].value)
                                }
                                break;

                            case "relationships":
                                for (let q = 0; q < data.answers[a].categories[c].questions.length; q++) {
                                    evaluationSubscale.relationshipPoints = (evaluationSubscale.relationshipPoints + data.answers[a].categories[c].questions[q].value)
                                }
                                break;

                            case "planning":
                                for (let q = 0; q < data.answers[a].categories[c].questions.length; q++) {
                                    evaluationSubscale.planningPoints = (evaluationSubscale.planningPoints + data.answers[a].categories[c].questions[q].value)
                                }
                                break;

                            case "results":
                                for (let q = 0; q < data.answers[a].categories[c].questions.length; q++) {
                                    evaluationSubscale.resultsPoints = (evaluationSubscale.resultsPoints + data.answers[a].categories[c].questions[q].value)
                                }
                                break;

                            case "resilience":
                                for (let q = 0; q < data.answers[a].categories[c].questions.length; q++) {
                                    evaluationSubscale.resiliencePoints = (evaluationSubscale.resiliencePoints + data.answers[a].categories[c].questions[q].value)
                                }
                                break;

                            case "supporting":
                                for (let q = 0; q < data.answers[a].categories[c].questions.length; q++) {
                                    evaluationSubscale.supportingPoints = (evaluationSubscale.supportingPoints + data.answers[a].categories[c].questions[q].value)
                                }
                                break;

                            case "progression":
                                for (let q = 0; q < data.answers[a].categories[c].questions.length; q++) {
                                    evaluationSubscale.progressionPoints = (evaluationSubscale.progressionPoints + data.answers[a].categories[c].questions[q].value)
                                }
                                break;

                        }



                    }
                }

                let evaluationScaleAverage = this.calculateEvaluationScore(evaluationSubscale)
                let evaluationScale = {
                    evaluationSubscale,
                    evaluationScaleAverage
                }
                return evaluationScale
            }

            else if (data.answers.length < 3) {
                return "inProgress"
            }

        },
        calculateEvaluationScore(evaluation) {
            evaluation.communicationPercentage = Math.round((evaluation.communicationPoints / 60)*100)
            evaluation.planningPercentage = Math.round((evaluation.planningPoints / 60)*100)
            evaluation.progressionPercentage = Math.round((evaluation.progressionPoints / 60)*100)
            evaluation.relationshipPercentage = Math.round((evaluation.relationshipPoints / 60)*100)
            evaluation.resiliencePercentage = Math.round((evaluation.resiliencePoints / 60)*100)
            evaluation.resultsPercentage = Math.round((evaluation.resultsPoints / 60)*100)
            evaluation.supportingPercentage = Math.round((evaluation.supportingPoints / 60)*100)
            
            this.total = ((evaluation.communicationPercentage + evaluation.planningPercentage + evaluation.progressionPercentage + evaluation.relationshipPercentage + evaluation.resiliencePercentage + evaluation.resultsPercentage + evaluation.supportingPercentage) / 7)
            return Math.round(this.total)
        },

        getChartDataEvaluationScale(evaluation){
            
            const chartData = {
                datasets: [
                  {
                    data: [
                     evaluation.evaluationScaleAverage,
                      100 - evaluation.evaluationScaleAverage,
                    ],
                    backgroundColor: [
                      this.adjustColor(evaluation.evaluationScaleAverage),
                    ],
                    borderWidth: 0,
                  },
                ],
                labels: [""],
              };

            return chartData;
        }
    }
};